import { NavLink } from "@admin/components/NavLink";
import { Facebook, Twitter, Instagram, Mail, Phone } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-muted/30">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* About */}
          <div>
            <h3 className="mb-4 text-lg font-bold">Jain Boarding Federation</h3>
            <p className="mb-4 text-sm text-muted-foreground">
              Connecting trustees, students, parents, and donors to strengthen
              Jain boarding education.
            </p>
            <div className="flex space-x-3">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="text-muted-foreground transition-colors hover:text-primary"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
                className="text-muted-foreground transition-colors hover:text-primary"
              >
                <Twitter size={20} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-muted-foreground transition-colors hover:text-primary"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="mb-4 font-semibold">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <NavLink
                  to="/about"
                  className="text-muted-foreground transition-colors hover:text-primary"
                >
                  About Us
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/institutions"
                  className="text-muted-foreground transition-colors hover:text-primary"
                >
                  Institutions
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/apply"
                  className="text-muted-foreground transition-colors hover:text-primary"
                >
                  Apply Now
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/events"
                  className="text-muted-foreground transition-colors hover:text-primary"
                >
                  Events
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="mb-4 font-semibold">Support</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <NavLink
                  to="/donors"
                  className="text-muted-foreground transition-colors hover:text-primary"
                >
                  Become a Donor
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/trustees"
                  className="text-muted-foreground transition-colors hover:text-primary"
                >
                  Trustee Portal
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/faq"
                  className="text-muted-foreground transition-colors hover:text-primary"
                >
                  FAQs
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  className="text-muted-foreground transition-colors hover:text-primary"
                >
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="mb-4 font-semibold">Contact Us</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li className="flex items-center space-x-2">
                <Mail size={16} />
                <span>info@jainboarding.org</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={16} />
                <span>+91 1800-XXX-XXXX</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between border-t pt-8 text-sm text-muted-foreground md:flex-row">
          <p>© {currentYear} Jain Boarding Federation. All rights reserved.</p>
          <div className="mt-4 flex space-x-6 md:mt-0">
            <NavLink
              to="/privacy"
              className="transition-colors hover:text-primary"
            >
              Privacy Policy
            </NavLink>
            <NavLink
              to="/terms"
              className="transition-colors hover:text-primary"
            >
              Terms of Service
            </NavLink>
            <NavLink
              to="/accessibility"
              className="transition-colors hover:text-primary"
            >
              Accessibility
            </NavLink>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
